export enum WidgetTypes {
  MarketOverview = 'MarketOverview',
  MarketHKNDistribution = 'MarketHKNDistribution',
  MarketSegmentsContractVolume = 'MarketSegmentsContractVolume',
  CustomersContractVolume = 'CustomersContractVolume',
  MarketHKNCustomers = 'MarketHKNCustomers',
  MarketHKNPositions = 'MarketHKNPositions',
  MarketCustomerAnalysis = 'MarketCustomerAnalysis',
}
